module.exports = __webpack_public_path__ + "img/case1-2.109d1ccc.png";